export class Concept {
  code: string;
  display: string;
}
